import { render, staticRenderFns } from "./CatalogGroupSelect.vue?vue&type=template&id=453ccf82&"
import script from "./CatalogGroupSelect.vue?vue&type=script&lang=js&"
export * from "./CatalogGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports